import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createUserDocumentWithGoogle = async (details) => {
    // get the reference to the Firestore document
    const docRef = db.doc(`/Users/${details.uid}`);

    //create user object
    const userProfile = {
        uid: details?.uid,
        email: details?.email,
        name: details?.fullName,
        userRole: details?.roleName,
        provider: details?.provider,
        storeName: details?.storeName,
        storeAddress: details?.storeAddress,
        storeWebsite: details?.storeWebsite,
        zipcode: details?.zipcode,
        gstNo: details?.gstNo,
        drugLicense: details?.drugLicense,
        nameTitle: details?.nameTitle ? details?.nameTitle : '',
        homeDelivery: details?.homeDelivery,
        areaCovers: details?.areaCovers,
        remarks: details?.remarks,
        phoneNumber: details?.phoneNumber,
        country: details?.country,
        isPlanActivated: true,
        createdAt: new Date(),
    };

    // write to Cloud Firestore
    await docRef.set(userProfile);
    const getBackUser = db.doc(`/Users/${details.uid}`);
    getBackUser.get().then(result => console.info(result));
}

export const createUserDocument = async (user, details) => {
    // get the reference to the Firestore document
    const docRef = db.doc(`/Users/${user.uid}`);

    //create user object
    const userProfile = {
        uid: user.uid,
        email: user.email,
        name: user.displayName,
        userRole: details?.roleName,
        storeName: details?.storeName,
        storeAddress: details?.storeAddress,
        storeWebsite: details?.storeWebsite,
        zipcode: details?.zipcode,
        gstNo: details?.gstNo,
        drugLicense: details?.drugLicense,
        nameTitle: details?.nameTitle ? details?.nameTitle : '',
        homeDelivery: details?.homeDelivery,
        areaCovers: details?.areaCovers,
        remarks: details?.remarks,
        phoneNumber: details?.phoneNumber,
        country: details?.country,
        isPlanActivated: true,
        createdAt: new Date(),
    };

    // write to Cloud Firestore
    await docRef.set(userProfile);
    const getBackUser = db.doc(`/Users/${user.uid}`);
    getBackUser.get().then(result => console.info(result));
}

export const createCandidateUserDocument = async (user, details) => {
    // get the reference to the Firestore document
    const docRef = db.doc(`/Users/${user.uid}`);

    //create user object
    const userProfile = {
        uid: user.uid,
        email: user.email,
        name: user.displayName,
        userRole: details?.roleName,

        nameTitle: details?.nameTitle,
        doe: details?.doe,
        cvDocument: details?.cvDocument,
        phoneNumber: details?.phoneNumber,
        profilePhoto: details?.profilePhoto,
        zipcode: details?.zipcode,

        facebookLink: details?.facebookLink,
        githubLink: details?.githubLink,
        instagramLink: details?.instagramLink,
        linkedInLink: details?.linkedInLink,
        stackOverFlowLink: details?.stackOverFlowLink,
        twitterLink: details?.twitterLink,

        currentCareerLevel: details?.currentCareerLevel,
        functionOrUniqueSKills: details?.functionOrUniqueSKills,
        productLevel: details?.productLevel,
        personalBio: details?.personalBio,
        availableFrom: details?.availableFrom,
        availableFromDate: details?.availableFromDate,
        hourPerWeek: details?.hourPerWeek,
        maxTravelDistanceFromHome: details?.maxTravelDistanceFromHome,
        maxTravelDistanceFromHomeKm: details?.maxTravelDistanceFromHomeKm,
        preferredContract: details?.preferredContract
    };

    // write to Cloud Firestore
    await docRef.set(userProfile);
    const getBackUser = db.doc(`/Users/${user.uid}`);
    getBackUser.get().then(result => console.info(result));
}

export const updateUserDocument = async (user) => {
    const docRef = db.doc(`/Users/${user.uid}`);
    return docRef.update(user);
}

export const uploadImage = (userId, file, progress) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const filePath = `logos/${userId}/company-logo`;
        const fileRef = storage.ref().child(filePath);

        // upload task
        const uploadTask = fileRef.put(file);
        uploadTask.on('state_changed', (snapshot) => progress(snapshot), (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const uploadImageUsingFilepath = (filePath, file) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const fileRef = storage.ref().child(filePath);

        // upload task
        const uploadTask = fileRef.put(file);
        uploadTask.on('state_changed', null, (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const uploadImageInBase64 = (userId, file, progress) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const filePath = `logos/${userId}/company-logo`;
        const fileRef = storage.ref().child(filePath);

        // upload task        
        const uploadTask = fileRef.putString(file, 'base64', {contentType:'image/jpeg'});
        uploadTask.on('state_changed', (snapshot) => progress(snapshot), (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const getDownloadUrl = async (userId) => {
    const filePath = `logos/${userId}/company-logo`;
    return await storage.ref().child(filePath).getDownloadURL().catch((err) => {
        
    });
}

export const getDownloadUrlFromFullPath = (filePath) => {
    return storage.ref().child(filePath).getDownloadURL();
}

export const uploadCVDocument = (filePath, file) => {
    return new Promise((resolve, reject) => {
        // create file reference
        //const filePath = `Resume/${userId}/company-logo`;
        const fileRef = storage.ref().child(filePath);

        // upload task
        const uploadTask = fileRef.put(file);
        uploadTask.on('state_changed', null, (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const getAllEmployerDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Users').where("userRole", "==", "Retailer").get()
    return snapshot.docs.map(doc => doc.data());
}

export const getAllEmployerDocumentWithCity = async (cityName) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Users').where("userRole", "==", "Retailer").where("storeCity", "==", cityName).get()
    return snapshot.docs.map(doc => doc.data());
}

export const getRetailerProfile = async (retailerId) => {
    // get the reference to the Firestore document
    let products = [];
    let retailer = null;
    const employerSnapshot = await db.collection('Users').where("uid", "==", retailerId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });

    const productSnapshot = await db.collection('Products').where("userId", "==", retailerId).get()
    productSnapshot.docs.map(doc => {
        products.push(doc.data())
    });
    return {
        products: products,
        retailer: retailer
    }
}

export const checkValidation = (params) => {
    if (params !== undefined && params !== '' && params !== null) {
        return true
    }
    return false
}

export const formParams = (params) => {
    if (params !== undefined && params !== '' && params !== null) {
        return params
    }
    return null
}